(() => {
  if (customElements.get('products-carousel')) return;

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.resizeHandler = null;

      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = { desktop: 990 };
    }

    connectedCallback() {
      requestAnimationFrame(() => this.init());
      this.resizeHandler = debounce(() => this.toggleSwiperHandler(), 300);
      window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
      this.destroySwiper();
    }

    init() {
      this.swiperContainer = this.querySelector('.products-carousel__slider');
      this.swiperNext = this.querySelector('.products-carousel__control-next');
      this.swiperPrev = this.querySelector('.products-carousel__control-prev');

      if (!this.swiperContainer) return;

      this.sizeCardSettings = {
        default: {
          slidesPerView: 1.2,
          spaceBetween: 32,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 2.75,
              spaceBetween: 48,
            },
          },
        },
        large: {
          slidesPerView: 1.1,
          spaceBetween: 24,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
          },
        },
      };

      this.mainSettings = {
        navigation: {
          nextEl: this.swiperNext,
          prevEl: this.swiperPrev,
        },
        speed: 300,
        ...this.sizeCardSettings[this.cardsSize],
      };

      this.toggleSwiperHandler();
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) {
        if (!this.swiper) this.createSwiper();
        return;
      }

      const shouldDestroy = window.innerWidth >= this.breakpoints.desktop;

      if (shouldDestroy) {
        this.destroySwiper();
      } else if (!this.swiper) {
        this.createSwiper();
      }
    }

    createSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(this.swiperContainer, this.mainSettings);
    }

    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();